const ContensisUris = (
  alias = window.ContensisAlias,
  project = window.ContensisProjectApiId
) => {
  const projectAndAlias =
    project && project.toLowerCase() !== 'website'
      ? `${project.toLowerCase()}-${alias}`
      : alias;
  return {
    api: `https://api-${alias}.cloud.contensis.com`,
    cms: `https://cms-${alias}.cloud.contensis.com`,
    liveWeb: `https://live-${projectAndAlias}.cloud.contensis.com`,
    previewWeb: `https://preview-${projectAndAlias}.cloud.contensis.com`,
    iisWeb: `https://iis-live-${projectAndAlias}.cloud.contensis.com`,
    iisPreviewWeb: `https://iis-preview-${projectAndAlias}.cloud.contensis.com`,
  } as const;
};

export default ContensisUris();
